export type ContactOfferKey = "general" | "lead-flow-watch" | "reactivate" | "recover" | "managed-sites" | "site-rescue" | "monitor";

export const contactOffers = {
  general: {
    interest: "Lead Flow Diagnostic",
    source: "lead_flow_diagnostic",
    eyebrow: "Request a Lead Flow Diagnostic",
    heading: "Where do leads arrive, stall, or disappear before revenue is recorded?",
    placeholder:
      "For example: leads come in from forms, calls, and booking requests, but routing is inconsistent and nobody trusts the CRM status or source tracking.",
    submitLabel: "Request a Lead Flow Diagnostic",
  },
  "lead-flow-watch": {
    interest: "Lead Flow Watch pilot",
    source: "lead_flow_watch_pilot",
    eyebrow: "Lead Flow Watch pilot",
    heading: "Which lead path should stop failing quietly?",
    placeholder:
      "For example: website inquiries should reach our CRM and an assigned owner, but we cannot tell when delivery or follow-up stalls.",
    submitLabel: "Ask About a Watch Pilot",
  },
  reactivate: {
    interest: "AAI Reactivate - $2,250 fixed-scope sprint",
    source: "reactivate_offer",
    eyebrow: "AAI Reactivate sprint",
    heading: "Which approved customer or estimate list should start producing conversations again?",
    placeholder:
      "For example: we have unsold replacement estimates from the last 90 days, with consent records and room on the schedule.",
    submitLabel: "Ask About the $2,250 Sprint",
  },
  recover: {
    interest: "AAI Recover - 30-day paid pilot",
    source: "recover_offer",
    eyebrow: "AAI Recover paid pilot",
    heading: "Where are service inquiries or estimates getting stuck?",
    placeholder:
      "For example: missed calls wait until the end of the day, and estimates rarely receive a second follow-up.",
    submitLabel: "Ask About the $750 Pilot",
  },
  "managed-sites": {
    interest: "Websites, migrations, and technical rescue review",
    source: "websites_rescue_offer",
    eyebrow: "Websites, migrations, and technical rescue",
    heading: "Does the customer-facing entry point make it easy for the right lead to arrive and reach the next owner?",
    placeholder:
      "For example: our site is outdated, form routing is unreliable, and we need a bounded rebuild without losing the details that matter.",
    submitLabel: "Request a Systems Review",
  },
  "site-rescue": {
    interest: "Website migration or technical rescue review",
    source: "site_rescue_offer",
    eyebrow: "Website migration and technical rescue",
    heading: "What needs to move, repair, or get unstuck without breaking the lead path?",
    placeholder:
      "For example: we need to rebuild a proprietary site in WordPress while preserving URLs, metadata, forms, internal links, and search visibility.",
    submitLabel: "Request a Systems Review",
  },
  monitor: {
    interest: "AAI Monitor demo",
    source: "monitor_demo",
    eyebrow: "AAI Monitor demo",
    heading: "Which lead path needs a reliable delivery check?",
    placeholder:
      "For example: website forms should reach two inboxes and the CRM, but nobody knows when a delivery step fails.",
    submitLabel: "Request a Monitor Demo",
  },
} as const;
